
import CurrencyConverter from "../common/currency-converter.vue";
import OrderOtpChipMobile from "./order-otp-chip-mobile.vue";

export default {
  props: {
    order: {},
    secondsSinceCreated: {
      type: Number,
      default: 0
    }
  },
  components: { OrderOtpChipMobile, CurrencyConverter }
};
